var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.title
        ? _c("el-divider", { attrs: { "content-position": "left" } }, [
            _vm._v("Title"),
          ])
        : _c("el-divider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }